import React from 'react'
import { Box, Typography, Link, CircularProgress } from '@mui/material'
import { LoginType } from '../../types/login.types'
import Input from "../../../../Components/InputV2/Input.component";
import {Button} from "../../../../Components/ButtonV2/Button.component";

const LoginForm: React.FC<LoginType> = ({ variables, actions }) => {
  const [user, setUser] = React.useState('')
  const [securityText, toggleVisible] = React.useState(true)

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: { xs: 10 },
        alignItems: 'center'
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: '#000000',
          textAlign: 'center',
          fontWeight: 600,
          fontSize: '32px'
        }}
      >
        Olá, <span style={{ color: 'rgba(3,90,199,1)' }}>de novo!</span>
      </Typography>
      <Typography
        sx={{
          color: 'var(--Grayscale-100, #69769b)',
          textAlign: 'center',
          letterSpacing: '0.15px',
          marginTop: '12px',
          fontSize: '16px',
          lineHeight: '24px'
        }}
      >
          Digite suas credenciais e você será redirecionado para o WhtasApp
      </Typography>
      <Box
        p={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '32px',
          width: { xs: '100%', md: '100%', lg: '50%' },
          gap: 2
        }}
      >
        <Input
          placeholder="CPF ou CNPJ"
          mask={
            variables.document.length < 15
              ? '999.999.999-999'
              : '99.999.999/9999-99'
          }
          filled={'true'}
          onChange={(e) => actions.onChangeDocument(e.target.value)}
          value={variables.document}
          labelText={'CPF ou CNPJ'}
          labelTextAnimated={true}
          type="text"
        />
        {!variables.error && variables?.hasManyUsers && (
          <>
            <Input
              placeholder="Usuário"
              filled={'true'}
              onChange={(e) => actions.onChangeUser(e.target.value)}
              value={variables?.user}
              labelText={'Usuário'}
              labelTextAnimated={true}
              type="text"
            />
          </>
        )}

        {!variables.error && variables?.documentVerified && (
          <Input
            placeholder="Senha"
            filled={'true'}
            onChange={(e) => actions.onChangePassword(e.target.value)}
            value={variables.password}
            labelText={'Senha'}
            labelTextAnimated={true}
            type="password"
            toggleVisible={() => toggleVisible(!securityText)}
            securityText={securityText}
          />
        )}

        {variables.error && (
          <Typography
            sx={{
              color: 'red',
              fontSize: '14px',
              marginTop: '8px'
            }}
          >
            {variables.errorMessage}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          style={{ width: '100%' }}
          onClick={
            !variables.error && variables?.documentVerified
              ? actions.onSubmitSignIn
              : actions.onVerifyDocument
          }
          disabled={variables.loading}
        >
          {variables.loading ? <CircularProgress size={24} /> : 'Confirmar'}
        </Button>
          {!variables.error && variables?.documentVerified && (
        <Button
          variant="outlined"
          textTransform="none"
          style={{ width: '100%' }}
        >
          Esqueci a senha
        </Button>
            )}
      </Box>
      <Typography
        sx={{
          color: 'var(--Grayscale-100, #69769b)',
          letterSpacing: '0.15px',
          marginTop: '32px',
          fontSize: '14px',
          lineHeight: '20px',
          textAlign: 'center'
        }}
      >
        Acesse nossos{' '}
        <Link
          target="_blank"
          href="https://rvdigitalbrasil.com.br/termos-e-condicoes-gerais.pdf"
          sx={{
            color: 'var(--RV_BLUE_LINKS, #006bee)',
            fontWeight: 600,
            textDecoration: 'none'
          }}
        >
          Termos de uso
        </Link>{' '}
        e{' '}
        <Link
          target="_blank"
          href="https://rvdigitalbrasil.com.br/politica-de-privacidade.html"
          sx={{
            color: 'var(--RV_BLUE_LINKS, #006bee)',
            fontWeight: 600,
            textDecoration: 'none'
          }}
        >
          Política de privacidade aqui
        </Link>
      </Typography>
    </Box>
  )
}

export default LoginForm
